import {
  Component,
  computed,
  inject,
  input,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { SearchFoldersStore } from './search-folders.store';
import {
    FolderGridItemObject,
} from '@it2go/types';
import { FilterBuilder } from '../../../helper/filter.builder';
import { InfiniteScrollStore } from '../../../../shared/store/common/infinite-scroll.store';
import { getPersonsFrag } from '../select-person/select-person.query';
import {
    MultiSelectInputComponent,
} from '../../../../../components/kit/input/multi-select-input/multi-select-input.component';
import { ChipModule } from '@openng/optimus-ui/chip';
import { FormatPersonPipe } from '../../../../shared/pipes/format-person.pipe';

@Component({
    selector: 'app-search-folders',
    templateUrl: 'search-folders.component.html',
    styleUrls: ['search-folders.component.scss'],
    providers: [SearchFoldersStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MultiSelectInputComponent,
        ChipModule,
        FormatPersonPipe,
    ],
})
export class SearchFoldersComponent extends SubscriptionComponent {
    public readonly store = inject(SearchFoldersStore);

    form = input.required<FormGroup>();
    id = input('folderIds');
    label = input('');
    serviceId = input<number | null | undefined>(null);
    filterFolderIds = input<number[]>([]);


    protected frag = `
        id
        person {
          ${getPersonsFrag}
        }
    `;

    public foldersScroll = computed(() => {
        const filter = new FilterBuilder();
        filter.serviceId(this.serviceId() || 0).limit(100);
        if (this.filterFolderIds()?.length) {
            filter.where('id', this.filterFolderIds() || [], 'NIN');
        }

        return new InfiniteScrollStore<FolderGridItemObject>(
            this.store.api.getFolders,
            filter.create(),
            true,
            this.frag,
        );
    });
}
